var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { parse, parseISO } from 'date-fns';
import { addDays, fromJSDateToISODateString, getDateObjectFromDateString, getIsoFormatDateFromDateString, getTodayDateBexFormat, isValidDate, isValidDateString } from './date-helper';
function areDatesEmpty(query) {
  return !query || !query.startDate && !query.endDate;
}
function isDateValid(query, date, localDateFormat) {
  var isValid = true;
  if (query[date]) {
    isValid = isValidDateString(query[date], localDateFormat);
  }
  return isValid;
}
function areDatesInvalid(query, localDateFormat) {
  return !(isDateValid(query, 'startDate', localDateFormat) && isDateValid(query, 'endDate', localDateFormat));
}
function populateMissingDateIfAny(criteriaQuery, localDateFormat) {
  if (criteriaQuery) {
    if (!criteriaQuery.startDate) {
      criteriaQuery = __assign(__assign({}, criteriaQuery), {
        startDate: criteriaQuery.endDate
      });
    } else if (!criteriaQuery.endDate) {
      var defaultEndDate = addDays(getDateObjectFromDateString(criteriaQuery.startDate, localDateFormat), 0);
      criteriaQuery = __assign(__assign({}, criteriaQuery), {
        endDate: isValidDate(defaultEndDate) ? fromJSDateToISODateString(defaultEndDate) : ''
      });
    }
  }
  return criteriaQuery;
}
export function handleInvalidDates(query, criteriaQuery, localDateFormat) {
  var criteriaQueryObject = __assign({}, criteriaQuery);
  if (areDatesInvalid(query, localDateFormat)) {
    criteriaQueryObject = __assign(__assign({}, criteriaQuery), {
      startDate: '',
      endDate: ''
    });
  } else if (!areDatesEmpty(query)) {
    criteriaQueryObject = populateMissingDateIfAny(criteriaQuery, localDateFormat);
  }
  return criteriaQueryObject;
}
export function getDateInput(dateString, localDateFormat) {
  var isoDate = new Date(getIsoFormatDateFromDateString(dateString, localDateFormat));
  var date = parse(dateString, localDateFormat, isoDate);
  if (isNaN(date.getDate())) {
    date = parseISO(dateString); // Could be in ISO Format
  }
  if (!isNaN(date.getDate())) {
    return {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear()
    };
  }
  return getTodayDateBexFormat();
}
export function activityDateRangeInput(criteriaQuery, localDateFormat) {
  if (!criteriaQuery) {
    return null;
  }
  var startDate = criteriaQuery.startDate,
    endDate = criteriaQuery.endDate;
  if (!startDate || !endDate) {
    return null;
  }
  return {
    startDate: getDateInput(startDate, localDateFormat),
    endDate: getDateInput(endDate, localDateFormat)
  };
}